import { render, staticRenderFns } from "./TimelineBlock.vue?vue&type=template&id=82be948a&scoped=true&"
import script from "./TimelineBlock.vue?vue&type=script&lang=ts&"
export * from "./TimelineBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineBlock.vue?vue&type=style&index=0&id=82be948a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82be948a",
  null
  
)

export default component.exports